import React, { Component } from 'react';
import { Helmet } from 'react-helmet';

class Heyo extends Component {
  componentDidMount() {
  }

  render() {
    function rot13(s) {
      /* eslint-disable */
      return s.replace(/[a-zA-Z]/g, c => String.fromCharCode((c <= 'Z' ? 90 : 122) >= (c = c.charCodeAt(0) + 13) ? c : c - 26));
      /* eslint-enable */
    }

    function emailObfuscate(event) {
      event.preventDefault();
      const mailToLink = rot13(event.target.href);
      window.location.href = mailToLink;
    }

    return (
      <div className="main-index main-index--heyo">
        <Helmet>
          <title>Hey, I’m Dan</title>
        </Helmet>
        <div className="index-page-buffer" />
        <div className="grid-row grid-8">
          <div className="grid-cell grid-cell--no-padding">
            <p className="quote quote--heyo">
              <q className="quote__text">You should always be trying to write a poem you are unable to write, a poem you lack the technique, the language, the courage to achieve. Otherwise you’re merely imitating yourself, going nowhere, because that’s always&nbsp;easiest.</q>
              <span className="quote__author">John Berryman</span>
            </p>
          </div>
        </div>

        <div className="grid-row grid-8">
          <div className="grid-cell grid-cell--no-flex">
            <p className="text--big text-align-center">
              People have paid me for <br />
              front-end development<br />
              design<br />
              Wordpress development<br />
              illustration<br />
              forklift operation<br />
              dish slinging<br />
              fish slinging <br />
              cake slinging <br />
              lawn mowing. <br /><br />
              {/*<a href="&#109;&#97;&#105;&#108;&#116;&#111;:&#100;&#97;&#110;&#64;&#100;&#97;&#110;&#111;&#104;&#108;&#115;&#101;&#110;&#46;&#99;&#111;&#109;">Get in touch</a>.*/}
              <a onClick={event => emailObfuscate(event)} href="znvygb:qna@qnabuyfra.pbz">Get in touch</a>.
            </p>
          </div>
        </div>

        <div className="grid-row grid-8">
          <div className="grid-cell grid-cell--no-flex">
            <a href="https://www.instagram.com/caramel_dan/" className="instagram-link">
              <svg className="instagram-link__svg" viewBox="0 0 93 93">
                <path d="M46.5,8.4c12.4,0,13.9,0,18.8,0.3c4.5,0.2,7,1,8.6,1.6c2.2,0.8,3.7,1.9,5.3,3.5 c1.6,1.6,2.6,3.2,3.5,5.3c0.6,1.6,1.4,4.1,1.6,8.6c0.2,4.9,0.3,6.4,0.3,18.8c0,12.4,0,13.9-0.3,18.8c-0.2,4.5-1,7-1.6,8.6 c-0.8,2.2-1.9,3.7-3.5,5.3c-1.6,1.6-3.2,2.6-5.3,3.5c-1.6,0.6-4.1,1.4-8.6,1.6c-4.9,0.2-6.4,0.3-18.8,0.3s-13.9,0-18.8-0.3 c-4.5-0.2-7-1-8.6-1.6c-2.2-0.8-3.7-1.9-5.3-3.5c-1.6-1.6-2.6-3.2-3.5-5.3c-0.6-1.6-1.4-4.1-1.6-8.6c-0.2-4.9-0.3-6.4-0.3-18.8 c0-12.4,0-13.9,0.3-18.8c0.2-4.5,1-7,1.6-8.6c0.8-2.2,1.9-3.7,3.5-5.3s3.2-2.6,5.3-3.5c1.6-0.6,4.1-1.4,8.6-1.6 C32.6,8.4,34.1,8.4,46.5,8.4 M46.5,0C33.9,0,32.3,0.1,27.3,0.3C22.4,0.5,19,1.3,16,2.4C13,3.6,10.4,5.2,7.8,7.8S3.6,13,2.4,16 c-1.1,3-1.9,6.3-2.2,11.3C0.1,32.3,0,33.9,0,46.5c0,12.6,0.1,14.2,0.3,19.2c0.2,4.9,1,8.3,2.2,11.3c1.2,3.1,2.8,5.7,5.4,8.2 c2.6,2.6,5.2,4.2,8.2,5.4c3,1.1,6.3,1.9,11.3,2.2c5,0.2,6.5,0.3,19.2,0.3s14.2-0.1,19.2-0.3c4.9-0.2,8.3-1,11.3-2.2 c3.1-1.2,5.7-2.8,8.2-5.4c2.6-2.6,4.2-5.2,5.4-8.2c1.1-3,1.9-6.3,2.2-11.3c0.2-5,0.3-6.5,0.3-19.2s-0.1-14.2-0.3-19.2 c-0.2-4.9-1-8.3-2.2-11.3c-1.2-3.1-2.8-5.7-5.4-8.2C82.6,5.2,80,3.6,77,2.4c-3-1.1-6.3-1.9-11.3-2.2C60.7,0.1,59.1,0,46.5,0L46.5,0z  M46.5,22.6c-13.2,0-23.9,10.7-23.9,23.9s10.7,23.9,23.9,23.9s23.9-10.7,23.9-23.9S59.7,22.6,46.5,22.6z M46.5,62 C37.9,62,31,55.1,31,46.5S37.9,31,46.5,31S62,37.9,62,46.5S55.1,62,46.5,62z M71.3,16.1c-3.1,0-5.6,2.5-5.6,5.6s2.5,5.6,5.6,5.6 s5.6-2.5,5.6-5.6S74.4,16.1,71.3,16.1z" />
              </svg>
            </a>
            <p className="text-align-center">Oh, hey. I&rsquo;m on the grams.</p>
          </div>
        </div>


        <div className="grid-row grid-8 actual-size-annotation">
          <div className="grid-cell grid-cell--no-flex">
            <p>* Well, probably closer to 87.3% actual size.</p>
          </div>
        </div>

      </div>
    );
  }
}


export default Heyo;



// WEBPACK FOOTER //
// ./src/components/Heyo.js